import React from "react";
import { smokeLabel, spiceLabel } from "../utils/game";

const COLUMNS = ["Korv", "Land", "Kött", "Rökighet", "Kryddighet", "Servering", "Struktur"];

function getCellClass(status) {
  if (status === "green") return "board-cell cell-green";
  if (status === "yellow") return "board-cell cell-yellow";
  return "board-cell cell-red";
}

function Hint({ direction }) {
  if (!direction) return null;
  return <span className="hint-arrow">{direction === "up" ? "↑" : "↓"}</span>;
}

export default function GuessHistory({ guesses, maxGuesses }) {
  return (
    <section className="glass-card section-card">
      <div className="section-header board-header-top">
        <h2>Dina gissningar</h2>
        <span>{guesses.length}/{maxGuesses}</span>
      </div>

      <div className="board-scroll">
        <div className="board-grid board-grid-header">
          {COLUMNS.map((column) => (
            <div key={column} className="board-heading">
              {column}
            </div>
          ))}
        </div>

        {guesses.length === 0 ? (
          <div className="empty-board">
            Inga gissningar ännu. Välj en korv och börja jaga dagens rätta svar.
          </div>
        ) : null}

        {guesses.map((entry) => {
          const guess = entry.guess;
          const comparison = entry.comparison;

          return (
            <div key={guess.id} className="board-grid board-row">
              <div className="board-cell cell-name">{guess.name}</div>
              <div className={getCellClass(comparison.country)}>{guess.country}</div>
              <div className={getCellClass(comparison.meats)}>{guess.meats.join(", ")}</div>
              <div className={getCellClass(comparison.smoke)}>
                <span>{smokeLabel(guess.smoke)}</span>
                <Hint direction={comparison.smokeHint} />
              </div>
              <div className={getCellClass(comparison.spice)}>
                <span>{spiceLabel(guess.spice)}</span>
                <Hint direction={comparison.spiceHint} />
              </div>
              <div className={getCellClass(comparison.serving)}>{guess.serving.join(", ")}</div>
              <div className={getCellClass(comparison.texture)}>{guess.texture}</div>
            </div>
          );
        })}
      </div>
    </section>
  );
}